import { useLocation } from 'react-router';
import { NavTabsContainer } from 'altus-ui-components';
import SystemRoutesContainer from 'app/components/SystemRoutesContainer';
import { Grid, Button } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import HistoryIcon from '@material-ui/icons/Restore';
import RiskMatrixHistoryDrawer from './history/RiskMatrixHistoryDrawer';
import { useToggle } from 'altus-hooks';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import useWellbore from 'features/wells/hooks/useWellbore';
import { loadIntegrityManagementIntegritiesForWell } from 'features/settings/integrityManagement/helpers/integrityManagement.actions';
import { useHeader } from 'app/hooks/useHeader';

const WellboreIntegrityContainer = ({
  breadcrumb,
  routes,
  classes,
  wellboreId,
  dispatchLoadIntegrityManagementForWell,
}) => {
  useHeader({ subTitle: breadcrumb });
  const { wellbore } = useWellbore(wellboreId);
  const [externalWellboreId, setExternalWellboreId] = useState(null);
  const [showHistoryDrawer, toggleHistoryDrawer] = useToggle();
  const location = useLocation();
  const hideTabs =
    location.pathname.includes('attachments') ||
    location.pathname.includes('history');

  useEffect(() => {
    if (wellbore.get('externalWellboreExternalId')) {
      dispatchLoadIntegrityManagementForWell(
        wellbore.get('externalWellboreExternalId'),
      );
      setExternalWellboreId(wellbore.get('externalWellboreExternalId'));
    }
  }, [dispatchLoadIntegrityManagementForWell, wellbore]);

  return (
    <>
      {!hideTabs && (
        <Grid item container>
          <Grid xs={10} item />
          <Grid xs={2} item className={classes.buttonContainer}>
            {showHistoryDrawer && (
              <RiskMatrixHistoryDrawer
                isOpen={showHistoryDrawer}
                toggleDrawer={toggleHistoryDrawer}
                externalWellboreId={externalWellboreId}
              />
            )}
            <Button
              title="Risk Score History"
              color="primary"
              variant="contained"
              className={classes.historyButton}
              onClick={() => toggleHistoryDrawer()}
            >
              <HistoryIcon fontSize="small" />
              History
            </Button>
          </Grid>
        </Grid>
      )}
      {!hideTabs && <NavTabsContainer routes={routes} />}
      <SystemRoutesContainer routes={routes} />
    </>
  );
};

const styles = (theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  historyButton: {
    backgroundColor: theme.palette.secondary.lighter,
    color: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.common.white,
    },
  },
});

export default compose(
  connect(() => {}, {
    dispatchLoadIntegrityManagementForWell:
      loadIntegrityManagementIntegritiesForWell,
  }),
  withStyles(styles),
)(WellboreIntegrityContainer);
